import {useCallback, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import {Container} from '@yosmanyga/rich-ui';
import type {NotesProps} from '@yosmanyga/fortaleza-core';
import {Notes, NotesHelp} from '@yosmanyga/fortaleza-core';
import {BlankLayout} from "../BlankLayout.tsx";

const NotesScreen = () => {
    const navigate = useNavigate();

    const scrollRef = useRef<HTMLDivElement>(null);

    const handleSend = useCallback(() => {
        if (!scrollRef.current) {
            return;
        }

        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }, []);

    const Layout = useCallback<NotesProps['templates']['layout']>(({
        list,
        input,
    }) => {
        return <BlankLayout
            ref={scrollRef}
            templates={{
                help: () => {
                    return <NotesHelp
                        templates={{
                            layout: Container,
                        }}
                    />
                },
                footer: () => {
                    return input
                }
            }}
            onBack={() => {
                navigate(-1);
            }}
        >
            {list}
        </BlankLayout>
    }, []);

    return <Notes
        templates={{
            layout: Layout,
        }}
        onSend={handleSend}
    />
};

export {NotesScreen};
